import React, { useContext, useEffect, useState } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import Footer from "../../components/comunes/Footer";
import { useNavigate } from "react-router-dom";
import { getToken } from "../../utils/auth";

const MetaConexion = () => {
    const { darkMode } = useContext(DarkModeContext);
    const navegacion = useNavigate();
    const [cargando, setCargando] = useState(true);

    useEffect(() => {
        const verificar = async () => {
            const token = getToken();
            if (!token) { navegacion("/"); return; }
            try {
                const r = await fetch(process.env.REACT_APP_API_TOKEN, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Token: token }),
                });
                if (!r.ok) navegacion("/");
            } catch { navegacion("/"); }
            finally { setCargando(false); }
        };
        verificar();
    }, [navegacion]);

    if (cargando) return null;

    const cardStyle = {
        borderRadius: 12,
        padding: "24px 28px",
        background: darkMode ? "#2c2f36" : "#fff",
        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        border: `1px solid ${darkMode ? "#3d4148" : "#e9ecef"}`,
        marginBottom: 20,
    };

    const codeStyle = {
        background: darkMode ? "#1a1d21" : "#f4f4f4",
        borderRadius: 8,
        padding: "12px 16px",
        fontSize: 12,
        fontFamily: "monospace",
        whiteSpace: "pre-wrap",
        wordBreak: "break-all",
        color: darkMode ? "#e2e8f0" : "#1a202c",
    };

    return (
        <div className={darkMode ? "bg-dark text-white min-vh-100" : "bg-light min-vh-100"}>
            <div className="container-fluid py-4 px-4" style={{ maxWidth: 900 }}>
                <h5 className="mb-1 fw-bold">Configuración de Meta APIs</h5>
                <p className="text-muted mb-4" style={{ fontSize: 13 }}>
                    Guía para conectar Zoco con la Graph API de Meta y aprobar la app para revisión.
                </p>

                {/* Webhook */}
                <div style={cardStyle}>
                    <h6 className="fw-bold mb-3">1. Webhook de Lead Ads</h6>
                    <p style={{ fontSize: 13 }}>El webhook ya está activo. Meta enviará los leads a esta URL:</p>
                    <div style={codeStyle}>
                        {window.location.origin}/api/meta/webhook
                    </div>
                    <p className="mt-3 mb-1" style={{ fontSize: 13 }}>
                        <strong>Verify Token:</strong> configurado en <code>Meta:VerifyToken</code> en appsettings.
                    </p>
                    <p style={{ fontSize: 13 }}>
                        En el panel de Meta for Developers → tu app → Webhooks → Agregar suscripción a <strong>leadgen</strong>.
                    </p>
                </div>

                {/* Permisos */}
                <div style={cardStyle}>
                    <h6 className="fw-bold mb-3">2. Permisos de la app (para revisión)</h6>
                    <table className="table table-sm" style={{ fontSize: 13 }}>
                        <thead>
                            <tr>
                                <th>Permiso</th>
                                <th>Uso</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><code>leads_retrieval</code></td>
                                <td>Leer datos de leads de formularios</td>
                            </tr>
                            <tr>
                                <td><code>pages_read_engagement</code></td>
                                <td>Ver información de páginas</td>
                            </tr>
                            <tr>
                                <td><code>pages_manage_ads</code></td>
                                <td>Administrar campañas de la página</td>
                            </tr>
                            <tr>
                                <td><code>ads_read</code></td>
                                <td>Leer métricas de campañas</td>
                            </tr>
                            <tr>
                                <td><code>pages_messaging</code></td>
                                <td>Enviar mensajes desde la página (futuro)</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Token */}
                <div style={cardStyle}>
                    <h6 className="fw-bold mb-3">3. Token de acceso</h6>
                    <p style={{ fontSize: 13 }}>
                        Generá un <strong>Page Access Token</strong> de larga duración desde el Graph API Explorer
                        y configurarlo en el servidor:
                    </p>
                    <div style={codeStyle}>
                        {`// appsettings.json
"Meta": {
  "VerifyToken": "tu_verify_token_secreto",
  "PageAccessToken": "EAAxxxxxxxxxxxxxx...",
  "AdAccountId": "act_123456789"
}`}
                    </div>
                </div>

                {/* Flujo del video */}
                <div style={cardStyle}>
                    <h6 className="fw-bold mb-3">4. Flujo para el video de revisión</h6>
                    <ol style={{ fontSize: 13, lineHeight: 2 }}>
                        <li>Un usuario completa el formulario de Lead Ads en Facebook/Instagram</li>
                        <li>Meta envía el lead via webhook a <code>/api/meta/webhook</code></li>
                        <li>El sistema guarda el lead en la tabla <code>LeadsMeta</code></li>
                        <li>El usuario Meta accede al panel en <strong>/meta/inicio</strong></li>
                        <li>Ve los leads en <strong>/meta/leads</strong> y puede gestionar el estado</li>
                        <li>Ve las campañas activas en <strong>/meta/campanas</strong></li>
                    </ol>
                </div>

                {/* Status */}
                <div style={cardStyle}>
                    <h6 className="fw-bold mb-3">5. Estado actual del sistema</h6>
                    <div className="d-flex flex-column gap-2" style={{ fontSize: 13 }}>
                        <StatusItem ok label="Webhook endpoint activo" detalle="POST /api/meta/webhook" />
                        <StatusItem ok label="Verificación de webhook" detalle="GET /api/meta/webhook?hub.mode=subscribe" />
                        <StatusItem ok label="Guardado automático de leads" detalle="Tabla LeadsMeta en base de datos" />
                        <StatusItem ok label="Panel de gestión de leads" detalle="/meta/leads — ver, filtrar, actualizar estado" />
                        <StatusItem ok label="Exportación a Excel" detalle="Desde el panel de leads" />
                        <StatusItem ok label="Campañas con Meta Ads API" detalle="Meta:AdAccountId configurado — tab 'Meta Ads' disponible en /meta/campanas" />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

function StatusItem({ ok, label, detalle }) {
    return (
        <div className="d-flex align-items-start gap-2">
            <span style={{ fontSize: 16, marginTop: 1 }}>{ok ? "✅" : "⚙️"}</span>
            <div>
                <div style={{ fontWeight: 600 }}>{label}</div>
                <div style={{ fontSize: 12, opacity: 0.7 }}>{detalle}</div>
            </div>
        </div>
    );
}

export default MetaConexion;
